import { Chip as ChipLib } from "@mui/material";

import styled from "styled-components";

export const Chip = styled(ChipLib)`
  border-radius: 24px;
  background: rgba(156, 211, 253, 0.12);
  height: 36px;
  padding: 8px 8px 8px 14px;

  .MuiChip-label {
    color: #9cd3fd;
    font-family: Raleway;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 110%;
    padding: 0;
    padding-right: 8px;
  }

  .MuiChip-deleteIcon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(156, 211, 253, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
    margin: 0;
    padding: 0;
    color: rgba(255, 255, 255, 0.5);

    &:hover {
      background: rgba(156, 211, 253, 0.25);
      color: rgba(255, 255, 255, 0.7);
    }
  }
`;
